import { Box, Grid, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const styles = {
  fullWidth: { xs: 12 },
  textBox: {
    mx: { xs: 0, sm: 0 },
  },
};

function SectionTitleWrapper({ title, children }: { title: string; children: React.ReactNode }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const marginTop = children ? 4 : 2;

  return (
    <Grid size={styles.fullWidth} mt={marginTop}>
      <Box sx={styles.textBox} mb={2}>
        <Typography
          color={theme.palette.text.secondary}
          fontSize={theme.fontSizes.sm}
          fontWeight={theme.typography.fontWeightRegular}
          textTransform='uppercase'
        >
          {t(title)}
        </Typography>
      </Box>
      {children}
    </Grid>
  );
}

export default SectionTitleWrapper;
